import axios from "axios";
import { BASE_URL } from "./api";


export async function getTimecardManagerRelationships(token, queryParams = "") {
    return axios({
        method: 'get',
        url: `${BASE_URL}/timecard-manager-relationships/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function createTimecardManagerRelationship(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/timecard-manager-relationships/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: payload,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function deactivateTimecardManagerRelationship(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/timecard-manager-relationships/${id}/deactivate/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function getUnassignedTimecardManagerUsers(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/timecard-manager-relationships/unassigned/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}
